import React from "react";
import { DefaultLinkFactory } from "@projectstorm/react-diagrams";
import ComponentLinkModel from "./CustomLinkModel";
import ComponentLinkWidget from "./CustomLinkWidget";


export default class ComponentLinkFactory extends DefaultLinkFactory {
  constructor() {
    super("component-link");
  }

  generateModel() {
    return new ComponentLinkModel({ engine: this.engine });
  }

  generateReactWidget(event) {
    return <ComponentLinkWidget link={event.model} diagramEngine={this.engine} />;
  }
}
